import {LoggedRoute} from './../../logged-route'
import {
  ElaAdaptiveSkillsPracticePreviewPrintAssignmentHandler,
  ElaArticlePreviewPrintAssignmentHandler,
  ElaTargetedSkillsPracticePreviewPrintAssignmentHandler,
  ElaFocusSkillsPracticePreviewPrintAssignmentHandler
} from './lazy'

export const routerV2ElaPrint = [
  {
    path: '/ela/print/adaptive-skills/:assignmentId',
    element: (
      <LoggedRoute component={ElaAdaptiveSkillsPracticePreviewPrintAssignmentHandler} fullScreen />
    )
  },
  {
    path: '/ela/print/targeted-skills/:assignmentSessionId',
    element: (
      <LoggedRoute component={ElaTargetedSkillsPracticePreviewPrintAssignmentHandler} fullScreen />
    )
  },
  {
    path: '/ela/print/focus-skills/:assignmentId',
    element: (
      <LoggedRoute component={ElaFocusSkillsPracticePreviewPrintAssignmentHandler} fullScreen />
    )
  },
  {
    path: '/ela/print/articles/:assignmentSessionId',
    element: <LoggedRoute component={ElaArticlePreviewPrintAssignmentHandler} fullScreen />
  },
  {
    path: '/ela/print/article/:articleUuid/level/:articleLevel',
    element: <LoggedRoute component={ElaArticlePreviewPrintAssignmentHandler} fullScreen />
  }
]
